import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { fetchRemittanceInstruction } from '../api/remittance-instructions.ts';
import { RemittanceInstruction } from '../models/remittance-instruction.ts';

export function useRemittanceInstruction(
  id: string,
): UseQueryResult<RemittanceInstruction, Error> {
  return useQuery({
    queryKey: ['remittanceInstructions', id],
    queryFn: () => fetchRemittanceInstruction(id),
  });
}
